import { Permission } from '@cims-online/shared'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreDsOrganizationMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  Organization,
  useOrganizationsTableContext,
} from '../../../../OrganizationsTableContext'

export function useRestore(): RestoreRowActionOptions<Organization> {
  const { refetch } = useOrganizationsTableContext()
  const [restore] = useRestoreDsOrganizationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreDSOrganization: {
        organization: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreDesignSubmittalOrganization,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
